import { useLocalSearchParams } from 'expo-router';
import { OpportunityPageView } from '../../../src/components/opportunity/OpportunityPageView';
import { usePublicPlanBundle } from '../../../src/hooks/usePublicPlanBundle';

/**
 * /opportunity/<planId>/<bundleId>: the public page where a vendor bids on a
 * bundle of defense work (see OpportunityPageView). It works signed out, so
 * the root layout lists it with the other public routes.
 */
export default function OpportunityScreen() {
  const { planId, bundleId } = useLocalSearchParams<{ planId: string; bundleId: string }>();
  return <OpportunityPageView state={usePublicPlanBundle(planId, bundleId)} />;
}
